const GalleryData = [
    {
        id: 1,
        cover: require("../../Assets/Gallery/gallery1.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 2,
        cover: require("../../Assets/Gallery/gallery2.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 3,
        cover: require("../../Assets/Gallery/gallery3.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 4,
        cover: require("../../Assets/Gallery/gallery4.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 5,
        cover: require("../../Assets/Gallery/gallery5.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 6,
        cover: require("../../Assets/Gallery/gallery6.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 7,
        cover: require("../../Assets/Gallery/gallery7.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 8,
        cover: require("../../Assets/Gallery/gallery8.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 9,
        cover: require("../../Assets/Gallery/gallery9.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 10,
        cover: require("../../Assets/Gallery/gallery10.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 11,
        cover: require("../../Assets/Gallery/gallery11.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 12,
        cover: require("../../Assets/Gallery/gallery12.jpg"),
        alttag: "Sobha Aranya",
    },
    {
        id: 13,
        cover: require("../../Assets/Gallery/gallery13.jpg"),
        alttag: "Sobha Aranya",
    },
   
]

export default GalleryData;